/* =================================================================
   PILATIX — Exit-intent "Before You Go" popup
   File: pltx2-exit-popup.js
   Triggers:
   - Desktop: mouseleave top of viewport (one-shot, armed after delay)
   - Mobile (optional): visibilitychange AWAY once, armed after delay
   Frequency capping via localStorage (configurable days).
   ================================================================= */

(function () {
  'use strict';
  if (typeof window === 'undefined') return;

  const STORAGE_KEY = 'pltx_exit_popup_shown_at';
  const root = document.querySelector('[data-pltx-exit]');
  if (!root) return;

  const frequencyDays = Math.max(1, parseInt(root.dataset.frequencyDays || '30', 10));
  const delayMs = Math.max(0, parseInt(root.dataset.delayMs || '3000', 10));
  const isTestMode = root.dataset.testMode === 'true';

  const canShow = () => {
    if (isTestMode) return true;
    try {
      const prev = parseInt(localStorage.getItem(STORAGE_KEY) || '0', 10);
      if (!prev) return true;
      const daysElapsed = (Date.now() - prev) / 86400000;
      return daysElapsed >= frequencyDays;
    } catch {
      return true; // if localStorage is blocked, still show
    }
  };

  const markShown = () => {
    try { localStorage.setItem(STORAGE_KEY, String(Date.now())); } catch {}
  };

  let shown = false;

  const show = () => {
    if (shown) return;
    if (!canShow()) return;
    shown = true;
    root.hidden = false;
    root.setAttribute('data-open', 'true');
    document.body.classList.add('pltx-exit-open');
    markShown();
    // Focus the primary button for a11y
    const firstBtn = root.querySelector('[data-pltx-exit-claim]');
    if (firstBtn) {
      setTimeout(() => { try { firstBtn.focus({ preventScroll: true }); } catch {} }, 100);
    }
  };

  const close = () => {
    if (!shown) return;
    root.hidden = true;
    root.removeAttribute('data-open');
    document.body.classList.remove('pltx-exit-open');
  };

  // Arm triggers after the configured delay
  let armed = false;
  setTimeout(() => { armed = true; }, delayMs);

  // Desktop exit intent: mouse leaving the top of the viewport
  const handleMouseLeave = (e) => {
    if (!armed || shown) return;
    // e.clientY is relative to viewport; <= 0 means exiting the top
    if (e.clientY <= 0 && !e.toElement && !e.relatedTarget) show();
  };
  document.addEventListener('mouseleave', handleMouseLeave);
  document.addEventListener('mouseout', handleMouseLeave);

  // Close triggers
  document.addEventListener('click', (e) => {
    if (e.target.closest('[data-pltx-exit-close]')) {
      e.preventDefault();
      close();
    }
  });
  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape' && !root.hidden) close();
  });

  // Claim button: opens the promo popup (email capture flow) if it exists
  // on the page. Otherwise falls back to navigating the href.
  const claimBtn = root.querySelector('[data-pltx-exit-claim]');
  if (claimBtn) {
    claimBtn.addEventListener('click', (e) => {
      markShown();
      const promoModal = document.querySelector('.sign-up-popup-modal');
      const promoOverlay = document.querySelector('.sign-up-popup-overlay');
      if (promoModal && promoOverlay) {
        // Intercept — close exit popup, open promo popup for email capture
        e.preventDefault();
        close();
        requestAnimationFrame(() => {
          promoModal.classList.add('popup-modal--active');
          promoOverlay.classList.add('popup-overlay--active');
          document.body.style.overflow = 'hidden';
        });
        return;
      }
      // No promo popup on the page — let the href navigate naturally
      // (default routes.root_url if no cta_url configured).
      close();
    });
  }

  // Test mode: show immediately on load
  if (isTestMode) {
    setTimeout(() => {
      armed = true;
      show();
    }, Math.min(delayMs, 500));
  }
})();
